import React from 'react'
import { Translate } from '../../../language'
import { AddPictureIcon } from '../../../assets/icons'
import './UploadImage.css'

const UploadImage = ({ isUpdate, fileUrl, onClick, type = '', classNameUpload = '' }) => {
    return (
        <div onClick={onClick} className={`profile-picture-upload ${classNameUpload} ${fileUrl ? 'load' : ''} ${type}`}>
            {fileUrl !== "" && fileUrl !== null ? < img className="img-upload-image" alt="" src={fileUrl} /> : <div>{type ==='' ? Translate('choosePhoto', 'es') : ''}</div>}
            {(!fileUrl || isUpdate) &&
                <div className="add-image-icon-content" >
                    <AddPictureIcon className="icon-add-picturee-register" />
                </div>}
        </div>
    )
}

export default UploadImage
